import getSymbol from './getSymbol';
/**
 * Add query parameters to a URL
 * @param {string} url - URL to add query parameters to
 * @param {Object} params - Query parameters to add
 * @returns {string} - URL with query parameters
 */

const addQueryParams = (url, params = {}) => {
  const queryString = Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
  return `${url}${getSymbol(url)}${queryString}`;
};

export default addQueryParams;
